<template>
  <div class="result-wrapper" :class="computer ? 'result-wrapper-pc' : ''">
    <header class="ant-layout-header">
      <div class="left">
        BOBO公式 <span class="header-label"> {{ modeText }}</span>
      </div>
    </header>

    <div class="user-info" v-if="computer">
      <div>
        患者姓名(Name):
        <a-input v-model:value="params.name" placeholder="患者姓名(Name)" />
      </div>
      <div>
        患者年龄(Age):
        <a-input v-model:value="params.age" placeholder="患者年龄(Age)" />
      </div>
      <div>
        患者ID:
        <a-input v-model:value="params.id" placeholder="患者ID" />
      </div>
      <div>
        医生(Surgeon):
        <a-input v-model:value="params.Surgeon" placeholder="医生(Surgeon)" />
      </div>
    </div>

    <a-divider v-if="computer"></a-divider>

    <a-layout-content style="padding: 0 20px">
      <div class="data-wrapper">
        <div class="params-space">
          <div class="eye" v-if="computer">右眼 <span>(OD)</span></div>
          <a-divider orientation="left" v-else>右眼(OD)</a-divider>
          <template v-if="rightTableData.length > 0">
            <div class="params-wrapper">
              <div>
                眼轴长： <span>{{ params.odal }}</span>
              </div>
              <div>
                K值(K1)：<span>{{ params.odk1 }}</span>
              </div>
              <div>
                K值(K2)：<span>{{ params.odk2 }}</span>
              </div>
              <div>
                前房深度(ACD)：<span>{{ params.odacd }}</span>
              </div>
              <div>
                目标屈光度(Target)：<span>{{ params.odtarget }}</span>
              </div>
              <div>
                A常数(A constant)：<span>{{ params.odaConstant }}</span>
              </div>
              <div>
                预算的IOL度数：<span>{{ params.odIOL }}</span>
              </div>
            </div>

            <a-table :columns="tableColums" :data-source="rightTableData" :pagination="false" />
          </template>
          <img v-else src="@/assets/img/page/empty.png" :class="computer ? 'empty-pc' : 'empty'" />
        </div>
        <div class="params-space">
          <div class="eye" v-if="computer">左眼 <span>(OS)</span></div>
          <a-divider orientation="left" v-else>左眼(OS)</a-divider>
          <template v-if="leftTableData.length > 0">
            <div class="params-wrapper">
              <div>
                眼轴长：<span>{{ params.osal }}</span>
              </div>
              <div>
                K值(K1)：<span>{{ params.osk1 }}</span>
              </div>
              <div>
                K值(K2)：<span>{{ params.osk2 }}</span>
              </div>
              <div>
                前房深度(ACD)：<span>{{ params.osacd }}</span>
              </div>
              <div>
                目标屈光度(Target)：<span>{{ params.ostarget }}</span>
              </div>
              <div>
                A常数(A constant)：<span>{{ params.osaConstant }}</span>
              </div>
              <div>
                预算的IOL度数：<span>{{ params.osIOL }}</span>
              </div>
            </div>
            <a-table :columns="tableColums" :data-source="leftTableData" :pagination="false" />
          </template>
          <img v-else src="@/assets/img/page/empty.png" :class="computer ? 'empty-pc' : 'empty'" />
        </div>
      </div>
    </a-layout-content>

    <div class="edit-btu" v-if="computer">
      <a-divider></a-divider>
      <a-space>
        <a-button @click="handlePrint" type="primary"> 打印(Print) </a-button>
        <a-button @click="handleNew" type="primary"> 新病例(New) </a-button>
        <a-button @click="handleEdit" type="primary"> 编辑(Edit) </a-button>
      </a-space>
    </div>

    <div class="edit-btu" v-else>
      <a-space>
        <a-button @click="handleNew" type="primary"> 新病例(New) </a-button>
        <a-button @click="handleEdit" type="primary"> 编辑(Edit) </a-button>
      </a-space>
    </div>

    <iframe v-if="showIframe" src="" frameborder="0" ref="iframe" class="print-iframe"></iframe>
  </div>
</template>

<script setup>
import { reactive, watch, ref, nextTick , computed } from "vue";
import { isComputer } from "@/utils/index";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const iframe = ref();

const computer = isComputer();

const mode = ref(1);

const modeText = computed(() => {
  if (mode.value === 1) {
    return "(此公式不适用于角膜屈光手术后的IOL计算)";
  }
  if (mode.value === 2) {
    return "不适用于RK术后 Don't for Post RK Surgery";
  }
});

const showIframe = ref(false);

const params = reactive({
  name: "",
  age: "",
  id: "",
  Surgeon: "",
  refractiveIndex: "1.3375",
  odal: "",
  odwtw: "",
  odcct: "",
  odlt: "",
  odaConstant: "",
  odtarget: "0",
  odacd: "",
  odk2: "",
  odk1: "",
  odIOL: "",
  osal: "",
  oswtw: "",
  oscct: "",
  oslt: "",
  osaConstant: "",
  ostarget: "0",
  osacd: "",
  osk2: "",
  osk1: "",
  osIOL: "",
});

const rightTableData = reactive([]);

const leftTableData = reactive([]);

const handleEdit = () => {
  router.replace("/calculate");
};

const tableColums = [
  {
    title: "IOL度数",
    dataIndex: "iol",
    align: "center",
  },
  {
    title: "残留屈光度(SE,D)",
    dataIndex: "se",
    align: "center",
  },
];

const getIOL = async (data, table) => {
  return new Promise((resolve, reject) => {
    const numbers = data.map((e) => Number(e));
    console.log(route.query)
    numbers.push(mode.value);
    fetch("https://visionhealthmed.com/IOL_Caculate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ numbers }),
    }).then((res) => {
      res.json().then((res) => {
        resolve(res);
      });
    });
  });
};

const setIOL = async (data) => {
  const { od, os, userInfo } = data;
  if (od.valid) {
    params.odal = od.params[1];
    params.odk1 = od.params[2];
    params.odk2 = od.params[3];
    params.odacd = od.params[4];
    params.odtarget = od.params[5];
    params.odaConstant = od.params[6];
    const res = await getIOL(data.od.params);
    const { IOL, results } = res;
    params.odIOL = Number(Number(IOL).toFixed(2));

    const iolList = results.splice(0, 9);
    const seList = results.map((e) => Number(e.toFixed(2)));

    for (let i = 0; i < iolList.length; i++) {
      rightTableData.push({ iol: iolList[i], se: seList[i] });
    }
  }

  if (os.valid) {
    params.osal = os.params[1];
    params.osk1 = os.params[2];
    params.osk2 = os.params[3];
    params.osacd = os.params[4];
    params.ostarget = os.params[5];
    params.osaConstant = os.params[6];
    const res = await getIOL(data.os.params);
    const { IOL, results } = res;
    params.osIOL = Number(Number(IOL).toFixed(2));

    const iolList = results.splice(0, 9);
    const seList = results.map((e) => Number(e.toFixed(2)));

    for (let i = 0; i < iolList.length; i++) {
      leftTableData.push({ iol: iolList[i], se: seList[i] });
    }
  }

  if (userInfo) {
    params.name = userInfo.name;
    params.age = userInfo.age;
    params.id = userInfo.id;
    params.Surgeon = userInfo.Surgeon;
  }
};

const handlePrint = () => {
  showIframe.value = true;
  params.mode = mode.value;
  nextTick(() => {
    iframe.value.style.display = "block";
    const serverUrl = `${window.location.origin}/QC/index.html#/printIol?params=${JSON.stringify(
      params
    )}&leftTableData=${JSON.stringify(leftTableData)}&rightTableData=${JSON.stringify(
      rightTableData
    )}`;
    const localUrl = `${window.location.origin}/#/printIol?params=${JSON.stringify(
      params
    )}&leftTableData=${JSON.stringify(leftTableData)}&rightTableData=${JSON.stringify(
      rightTableData
    )}`;
    const url = process.env.NODE_ENV === "production" ? serverUrl : localUrl;
    iframe.value.src = url;
  });
};

window.addEventListener("message", (e) => {
  if (e.type === "message" && e.data === "closeIframe") {
    iframe.value.src = "";
    iframe.value.style.display = "none";
    showIframe.value = false;
  }
});

const handleNew = () => {
  router.replace("/calculate?type=new");
};

watch(
  route,
  (val) => {
    if (val.path === "/iolresult") {
      rightTableData.length = 0;
      leftTableData.length = 0;
      Object.keys(params).forEach((e) => {
        params[e] = "";
      });
      const data = JSON.parse(val.query.calc);
      mode.value = Number(data.mode);
      setIOL(data);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);
</script>

<style lang="less" scoped>
.print-iframe {
  z-index: -1 !important;
  left: -100vw;
  top: -100vh;
}

.result-wrapper {
  height: 100vh;
  overflow-y: scroll;
}

.edit-btu {
  margin: 20px auto;
  text-align: center;
}

/deep/ .ant-divider-horizontal {
  margin: 30px 0;
}

.custom-form .ant-divider-horizontal.ant-divider-with-text-left:before,
.custom-form .ant-divider-horizontal.ant-divider-with-text-left:after {
  top: 0%;
}

.empty {
  width: 300px;
  height: 190px;
}

.ant-layout-header {
  padding: 0 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 1px;
  display: flex;
  justify-content: space-between;
  background: linear-gradient(135deg, #35b7ad 10%, #abdcff);
  color: #fff;
  font-size: 18px;
  font-weight: 600;

  span {
    color: #f5222d;
    font-size: 12px;
    margin-left: 10px;
    font-weight: 500;
    background-color: rgb(255 255 255 / 30%);
    border-radius: 5px;
    padding: 5px;
  }
}

.params-wrapper {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  justify-content: space-between;
  margin-bottom: 20px;

  div {
    width: 180px;
    color: #666;
    margin-bottom: 5px;

    span {
      color: #37aea5;
      display: inline-block;
      font-size: 12px;
    }
  }
}

.result-wrapper-pc {
  .ant-layout-header {
    height: 0.42rem;
    line-height: 0.42rem;
    padding-left: 0.52rem;
    font-size: 0.17rem;

    span {
      font-weight: 400;
      font-size: 0.09rem;
      color: #ffffff;
      background: none;
    }
  }

  .empty-pc {
    width: 2.92rem;
    height: 1.8rem;
  }

  .data-wrapper {
    display: flex;
    padding: 0 1.78rem;
    justify-content: space-between;
    width: 100%;

    /deep/ .ant-table-thead>tr>th {
      background: #fafafa;
    }

    /deep/ .ant-table-thead>tr>th {
      padding: 8px;
      font-size: 0.07rem;
    }

    /deep/.ant-table-tbody>tr>td {
      padding: 8px;
      font-size: 0.07rem;
    }

    /deep/ tbody :nth-child(5)>td {
      color: #35b7ad;
    }

    .params-wrapper {
      font-size: 0.07rem;

      div {
        width: 0.86rem;
      }

      span {
        font-size: 0.07rem;
      }
    }

    .params-space {
      width: 2.92rem;
    }

    .eye {
      font-size: 0.13rem;
      color: #333333;
      line-height: 0.18rem;
      letter-spacing: 1px;
      font-weight: bold;
      margin-bottom: 0.16rem;

      span {
        font-weight: 400;
        font-size: 0.07rem;
        color: #333333;
        line-height: 0.1rem;
        letter-spacing: 1px;
      }
    }
  }

  .user-info {
    display: flex;
    justify-content: space-between;
    padding: 0 1.88rem;
    width: 100%;

    div {
      display: flex;
      letter-spacing: 1px;
      font-size: 0.07rem;
      align-items: center;
      margin-top: 0.12rem;

      ::v-deep input {
        text-align: center;
        border: none;
        border-bottom: 1px solid #999999;
        width: 0.75rem;
        font-size: 0.07rem;
      }

      ::v-deep .ant-input:focus {
        box-shadow: none;
      }
    }
  }

  button {
    font-size: 0.07rem;
    height: 0.16rem;
  }
}
</style>
